<div class="header">
  <div class="title">Disposition</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<form [formGroup]="dispositionForm">
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Name</mat-label>
      <input matInput [formControlName]="'name'" />
    </mat-form-field>
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Offer Price</mat-label>
      <input matInput currencyMask [formControlName]="'amount'" [options]="currencyMaskOptions" />
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Type</mat-label>
      <mat-select [formControlName]="'transaction_type'">
        <mat-option value="bid"> Bid </mat-option>
        <mat-option value="counter"> Counter </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Status</mat-label>
      <mat-select [formControlName]="'workflow_state'">
        <mat-option *ngFor="let state of states" [value]="state">
          {{ state | titlecase }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>DD Days</mat-label>
      <input matInput [formControlName]="'due_diligence_period'" />
    </mat-form-field>
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Closing Days</mat-label>
      <input matInput [formControlName]="'closing_period'" />
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Offer Date</mat-label>
      <input
        matInput
        [matDatepicker]="offerSentDatePicker"
        [formControlName]="'sent_at'"
        [placeholder]="'Offer Date'"
      />
      <mat-datepicker-toggle matSuffix [for]="offerSentDatePicker"> </mat-datepicker-toggle>
      <mat-datepicker #offerSentDatePicker></mat-datepicker>
      <mat-hint class="date-format-hint">YYYY-MM-DD</mat-hint>
    </mat-form-field>
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Earnest Money</mat-label>
      <input matInput currencyMask [formControlName]="'earnest_money'" [options]="currencyMaskOptions" />
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Note</mat-label>
      <input matInput [formControlName]="'description'" />
    </mat-form-field>
  </div>
  <div class="actions">
    <div class="formatting">
      @if (canDeleteDisposition()) {
        <button mat-icon-button *ngIf="disposition && disposition.id">
          <mat-icon [svgIcon]="'delete'" (click)="deleteDisposition()"></mat-icon>
        </button>
      }
    </div>
    <div class="buttons">
      <button class="discard-button" mat-button (click)="discard()" type="button">
        <span>Cancel</span>
      </button>
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        [disabled]="isSaveBtnDisabled"
        DebounceClick
        (debounceLoading)="isDebounceLoading($event)"
        (debounceClick)="save()"
      >
        <span *ngIf="!isLoading || !dispositionForm.disabled">Save</span>
        <mat-progress-spinner *ngIf="isLoading || dispositionForm.disabled" [diameter]="24" [mode]="'indeterminate'">
        </mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
